import Vue from 'vue';
import Vuex from 'vuex';
import VueLocalStorage from 'vue-localstorage';

import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);
Vue.use(VueLocalStorage);

const storageName = 'vkb-2mk05';

const init_state = {
  appConfigs: [],
  internshipState: {},
  trackingData: []
};

const getInitialState = (reset = true) => {
  let state = Vue.localStorage.get(storageName, null);

  if (!state || reset) {
    state = {};
    Object.keys(init_state).map(key => {
      state[key] = (init_state[key]);
    });
    return state;
  }

  return JSON.parse(state);
};

export default new Vuex.Store({
  state: getInitialState(false),
  getters,
  mutations: {
    ...mutations,
    RESET_STATE (state) {
      const state_ = getInitialState(true);

      Object.keys(state_)
        .map(key => {
          state[key] = state_[key];
        });

      Vue.localStorage.set(storageName, JSON.stringify(state_));
    },
  },
  actions
});



// WEBPACK FOOTER //
// ./src/store/store.js